import {
  Edit,
  Settings,
  ArrowBack,
} from "@mui/icons-material";
import { Button, ButtonGroup, IconButton } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useMatStyles from "./style";
import Layout from "../../../components/Layout";
import { customBaseUrl, httpDelete, httpGet, httpPut } from "../../../store/http";
import NotificationManager from "react-notifications/lib/NotificationManager";
import { hideLoader, showLoader } from "../../../utils/loader";
import EditPricing from "./modals/EditPricing";
import ManageCommissions from "./modals/manageCommissions";
import CreateCommission from "./modals/createCommission";
import AddPricing from "./modals/AddPricing";

const ProductPricing = () => {
  const [pricings, setPricings] = useState([]);
  const [pricingData, setPricingData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showManageModal, setShowManageModal] = useState(false);
  const [showAddCom, setShowAddCom] = useState(false);
  const [showAddPricing, setShowAddPricing] = useState(false);
  const [pagination, setPagination] = useState({ current: 0, pageSize: 20 });
  const [metaData, setMetaData] = useState(0);
  const [allReferrals, setAllreferrals] = useState([]);
  const [comList, setComList] = useState({})
  const [amountType, setAmountType] = useState([]);
  const [tranType, setTranType] = useState([]);
  const [tranName, setTranName] = useState([]);
  const [debitSrc, setDebitSrc] = useState([]);


  const styles = useMatStyles();
  const navigation = useNavigate();

  
  const handleOpenEditModal = (pricing) => {
    setPricingData(pricing);
    setShowModal(true);
  };

  const editAggregatorCommission = async () => {
    showLoader();
    const url = `${customBaseUrl.commissionUrl}/api/v1/organisation`;
    const response = await httpPut(url, pricingData);
    if (response.status === true) {
      NotificationManager.success(response.message);
      getPricing();
      setShowModal(false);
      setShowManageModal(false);
      setPricingData({})
      hideLoader();
    } else {
      NotificationManager.error(response.message);
      hideLoader();
    }
  };

  const deleteAggregatorCommission = async () => {
    showLoader();
    const url = `${customBaseUrl.commissionUrl}/api/v1/organisation`;
    const response = await httpDelete(url, pricingData);
    if (response.status === true) {
      NotificationManager.success(response.message);
      getPricing();
      hideLoader();
    } else {
      NotificationManager.error(response.message);
      hideLoader();
    }
  };

  const handleChangeRowsPerPage = async (value) => {
    setPagination({ ...pagination, current: 0, pageSize: value });
    await getPricing(0, value);
  };

  const handleChangePage = async (newPage) => {
    setPagination({ ...pagination, current: newPage });
    await getPricing(newPage, pagination.pageSize);
  };



  const getPricing = async (page,size) => {
    showLoader();
    const pages = page ?? pagination.current;
    const limit = size ? size : pagination.pageSize;

    const response = await httpGet(
      `${customBaseUrl.integUrl}/api/v1/pricing/products?pageNumber=${pages}&pageSize=${limit}&paged=true`
    );
    if (response.status === true) {
      setPricings(response.data.content);
      setMetaData(response.data?.totalElements);
      hideLoader();
    } else {
      NotificationManager.error(response.message, "Oops!", 3000);
      hideLoader();
    }
  };

  const columns = [
    {
      field: "productName",
      headerName: "Product Name",
      width: 200,
      headerClassName: styles.tableHeader,
    },
    {
      field: "pricingName",
      headerName: "Pricing Name",
      width: 150,
      headerClassName: styles.tableHeader,
    },
    {
      field: "pricingDescription",
      headerName: "Description",
      width: 250,
      headerClassName: styles.tableHeader,
    },
    {
      field: "pricingModel",
      headerName: "Pricing Model",
      width: 150,
      headerClassName: styles.tableHeader,
    },
    {
      field: "basePrice",
      headerName: "Base Price",
      headerClassName: styles.tableHeader,
      width: 150,
      valueGetter: ({ row }) => {
        return `${row.basePrice} ${row.currency}`;
      },
    },
    {
      field: "effectiveFrom",
      headerName: "Effective From",
      headerClassName: styles.tableHeader,
      width: 200,
      valueGetter: ({ value }) => value && new Date(value).toLocaleString(),
    },
    {
      field: "effectiveTo",
      headerName: "Effective To",
      headerClassName: styles.tableHeader,
      width: 200,
      valueGetter: ({ value }) => value && new Date(value).toLocaleString(),
    },
    {
      field: "active",
      headerName: "Status",
      headerClassName: styles.tableHeader,
      width: 100,
      renderCell: ({row}) => row?.active ? 'Active' : 'Inactive'
    },
    {
      field: "actions",
      headerName: "ACTIONS",
      headerClassName: styles.tableHeader,
      type: "actions",
      width: 150,
      renderCell: ({ row }) => {
        return (
          <div key={row.id}>
            <ButtonGroup variant="text">
              <IconButton
                onClick={() => handleOpenEditModal(row)}
                style={{ color: "#303030" }}
                aria-label="edit"
                component="span"
              >
                <Edit />
              </IconButton>
            </ButtonGroup>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    getPricing();
  }, []);
  return (
    <Layout>
      <div >
        <ArrowBack onClick={()=>{
          navigation('/transactions/commissions')
        }}/>
      </div>
      <div className="row">
        <div className="col-md-12">
          <Button variant="contained"
            onClick={() => setShowAddPricing(true)}
            style={{
              float: "right",
              fontFamily: "Inter",
              background: "#ff6700",
            }} startIcon={<Settings />}>
            Add New Pricing
          </Button>


        </div>
        <div
          style={{ height: 800, width: "100%", marginTop: "25px" }}
          className="col-md-12"
        >
        

      <DataGrid
            className={styles.table}
            rows={pricings?.length > 0 ? pricings : []}
            density="comfortable"
            columns={columns}
            page={pagination.current}
            paginationMode="server"
            pageSize={pagination.pageSize}
            onPageSizeChange={(newPageSize) =>
              handleChangeRowsPerPage(newPageSize)
            }
            onPageChange={(newPage) => handleChangePage(newPage)}
            rowsPerPageOptions={[5, 10, 20, 50, 100]}
            pagination
            components={{ Toolbar: GridToolbar }}
            rowCount={metaData}
          />
        </div>
      </div>
      {showModal && (
        <EditPricing
          showModal={showModal}
          setShowModal={setShowModal}
          pricingData={pricingData}
          getPricing={getPricing}
        />
      )}
      {showManageModal && (
        <ManageCommissions
          showModal={showManageModal}
          setShowModal={setShowManageModal}
          commissionList={pricings}
          commissionData={pricingData}
          setCommissionData={setPricingData}
          handleSubmit={editAggregatorCommission}
          comList={comList}
        />
      )}
      {showAddCom && (
        <CreateCommission
          showModal={showAddCom}
          setShowModal={setShowAddCom}
          allReferrals={allReferrals}
          tranType={tranType}
          amountType={amountType}
          tranName={tranName}
          debitSrc={debitSrc}
        />
      )}
      {showAddPricing && (
        <AddPricing
          showModal={showAddPricing}
          setShowModal={setShowAddPricing}
          getPricing={getPricing}
        />
      )}
    </Layout>
  );
};
export default ProductPricing;